import React, { useState } from 'react'
import { Box, TextField, Typography, ClickAwayListener, Rating, Slider, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { useSurveyStore } from '../../surveyutilities/surveyStore'

function RatingBlock({ block, position }) {
    const [editingTitle, setEditingTitle] = useState(false);
    const [editingDescription, setEditingDescription] = useState(false);
    const updateQuestion = useSurveyStore((state) => state.updateQuestion);

    const handleTitleClick = () => setEditingTitle(true);
    const handleDescriptionClick = () => setEditingDescription(true);
    const handleClickAway = () => {
        setEditingTitle(false);
        setEditingDescription(false);
    };

    const handleTitleChange = (event) => {
        updateQuestion(block.internalId, { title: event.target.value });
    };

    const handleDescriptionChange = (event) => {
        updateQuestion(block.internalId, { description: event.target.value });
    };

    const handleRatingTypeChange = (event) => {
        updateQuestion(block.internalId, { ratingType: event.target.value });
    };

    const handleMinMaxChange = (field, value) => {
        updateQuestion(block.internalId, { [field]: value });
    };

    const handleLabelChange = (field, value) => {
        updateQuestion(block.internalId, { [field]: value });
    };

    return (
        <Box>
            <ClickAwayListener onClickAway={handleClickAway}>
                <Box>
                    {editingTitle ? (
                        <TextField
                            autoFocus
                            fullWidth
                            value={block.title}
                            onChange={handleTitleChange}
                            onBlur={handleClickAway}
                            variant="outlined"
                            sx={{ mb: 1 }}
                        />
                    ) : (
                        <Typography
                            sx={{ mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                            onClick={handleTitleClick}
                        >
                            {position + 1}. {block.title} {block.required ? <span style={{color: 'red'}}>*</span> : ''}
                        </Typography>
                    )}

                    {editingDescription ? (
                        <TextField
                            autoFocus
                            fullWidth
                            value={block.description}
                            onChange={handleDescriptionChange}
                            onBlur={handleClickAway}
                            variant="outlined"
                            multiline
                            maxRows={4}
                            sx={{ mb: 1 }}
                        />
                    ) : (
                        <Typography
                            variant="body2"
                            sx={{ mb: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f5f5f5' } }}
                            onClick={handleDescriptionClick}
                        >
                            {block.description}
                        </Typography>
                    )}

                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel>Rating Type</InputLabel>
                        <Select
                            value={block.ratingType || 'stars'}
                            onChange={handleRatingTypeChange}
                            label="Rating Type"
                        >
                            <MenuItem value="stars">Stars</MenuItem>
                            <MenuItem value="numbers">Numbers</MenuItem>
                            <MenuItem value="scale">Scale</MenuItem>
                        </Select>
                    </FormControl>

                    {block.ratingType === 'stars' && (
                        <Box sx={{ textAlign: 'center', py: 2 }}>
                            <Rating
                                value={3}
                                max={block.maxValue || 5}
                                readOnly
                                size="large"
                            />
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                <Typography variant="caption">{block.minLabel || 'Poor'}</Typography>
                                <Typography variant="caption">{block.maxLabel || 'Excellent'}</Typography>
                            </Box>
                        </Box>
                    )}

                    {block.ratingType === 'numbers' && (
                        <Box sx={{ px: 2 }}>
                            <Slider
                                value={3}
                                min={block.minValue || 1}
                                max={block.maxValue || 5}
                                step={1}
                                marks
                                valueLabelDisplay="on"
                                disabled
                            />
                        </Box>
                    )}

                    {block.ratingType === 'scale' && (
                        <Box sx={{ textAlign: 'center', py: 2 }}>
                            <Typography variant="h4" color="primary">
                                {3}/{block.maxValue || 5}
                            </Typography>
                        </Box>
                    )}

                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <TextField
                            label="Min Value"
                            type="number"
                            value={block.minValue || 1}
                            onChange={(e) => handleMinMaxChange('minValue', parseInt(e.target.value))}
                            size="small"
                        />
                        <TextField
                            label="Max Value"
                            type="number"
                            value={block.maxValue || 5}
                            onChange={(e) => handleMinMaxChange('maxValue', parseInt(e.target.value))}
                            size="small"
                        />
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                        <TextField
                            label="Min Label"
                            value={block.minLabel || ''}
                            onChange={(e) => handleLabelChange('minLabel', e.target.value)}
                            size="small"
                            fullWidth
                        />
                        <TextField
                            label="Max Label"
                            value={block.maxLabel || ''}
                            onChange={(e) => handleLabelChange('maxLabel', e.target.value)}
                            size="small"
                            fullWidth
                        />
                    </Box>
                </Box>
            </ClickAwayListener>
        </Box>
    );
}

export default RatingBlock;